export function formatSegmentTitle(title) {
  return title.replace(/_/g, ' ');
}
